__turbopack_context__.v({
  "paddingNone": "_5BwuMW_paddingNone",
  "section": "_5BwuMW_section",
  "strongText": "_5BwuMW_strongText",
});
